import React, { Component } from "react";
import * as s from "./SearchBar.module.scss";
import { Overlay } from "src/views/shared/components";
import { inject, observer } from "mobx-react";
import { AdvancedSearchStore, UIStore } from "src/stores";
import { AdvancedSearchBar } from "./AdvancedSearchBar";
import { AdvancedSearchOverlay } from "./AdvancedSearchOverlay";
import { tx } from "src/libs/i18n";
import { P } from "resource-centre-theme/src/views/shared/components";
import { Icons } from "src/libs/assets";

interface Props {
  advancedSearchStore?: AdvancedSearchStore;
  uiStore?: UIStore;
}

@inject("advancedSearchStore", "uiStore")
@observer
export class SearchBar extends Component<Props> {
  render() {
    const { advancedSearchStore, uiStore } = this.props;
    const { isDesktop } = uiStore;
    const {
      advancedSearchOverlayOpen,
      advancedSearchActive,
      toggleAdvancedSearchActive,
      toggleAdvancedSearchOverlay
    } = advancedSearchStore;

    let wrapperClasses = [s.searchBarsContainer];

    if (!advancedSearchActive) {
      wrapperClasses.push(s.withPadding);
    }

    return (
      <div className={wrapperClasses.join(" ")}>
        {/* {!advancedSearchActive && isDesktop && (
          <div className={s.toggleContainer}>
            <h3>{tx("search.needToNarrowItDownMore")}</h3>
            <div
              className={s.toggleRow}
              onClick={() => {
                toggleAdvancedSearchActive();
                toggleAdvancedSearchOverlay();
              }}
            >
              <P>{tx("search.advancedSearch")}</P>
              <img src={Icons.dropdown_small} />
            </div>
          </div>
        )}
        {!advancedSearchActive && !isDesktop && <div className={s.divider} />}
        {advancedSearchActive && <AdvancedSearchBar />}
        {advancedSearchOverlayOpen && (
          <Overlay>
            <AdvancedSearchOverlay />
          </Overlay>
        )} */}
      </div>
    );
  }
}
